import { FeatureFlagSet } from '@/types';

/**
 * Base URL of our backend-for-frontend (BFF).
 * This is just our own origin, since our BFF serves UI assets to us.
 * Falls back to localhost when window.origin is unavailable (e.g. test environments).
 */
export const BACKEND_URL = (() => {
  try {
    return new URL(window.origin);
  } catch {
    return new URL('https://localhost');
  }
})();

export const HTTP_STATUS_NO_CONTENT = 204;

export const SECURE_PROTOCOL = /https|wss/;

export const INTERNAL_ORG_ID = '1beb94ab-0733-4b2e-b777-abb6954e4dd2';

export const LocalStorageKeys = {
  FacilitySlug: 'facilitySlug',
  ExpandedLeftNav: 'expandedLeftNav',
  ExpandedOrganizationSections: 'expandedOrganizationSections',
  ExpandedNavSections: 'expandedNavSections',
  ExpandedEquipmentBrowserAdvanced: 'expandedEquipmentBrowserAdvanced',
  EquipmentBrowserSectionStates: 'equipmentBrowserSectionStates',
  EquipmentBrowserTableSectionStates: 'equipmentBrowserTableSectionStates',
  ReportsSectionStates: 'reportsSectionStates',
  ViteUITheme: 'vite-ui-theme',
} as const;
export type LocalStorageKey = (typeof LocalStorageKeys)[keyof typeof LocalStorageKeys];

export const SUPPORT_CONTACT_NUMBER = '(866) 285-2755';

export const FACILITY_FRAME_ID = 'facility-frame';

export const ACCESS_TOKEN_KEY = 'accessToken';

export const APP_CONFIG_KEY = 'app-config';

/**
 * Port for LaunchDarkly relay proxy in agent mode.
 * The relay runs on the agent hardware at this port.
 */
export const LAUNCH_DARKLY_RELAY_PORT = '13372';

/**
 * Feature flag names for type-safe access
 */
export const FEATURE_FLAGS = {
  DEMAND_RESPONSE_PAGES: 'demand-response-pages',
  GAIA_BETA_TOOLS: 'gaia-beta-tools',
  GAIA_PROCESS: 'gaia-process',
  MAIN_PAGE_REDIRECT: 'main-page-redirect',
  PREDICTIVE_DRYING_CONTROL: 'predictive-drying-control',
  THEME_TOGGLE: 'theme-toggle',
} as const;

/**
 * Defaults for all flags, for use when feature-flag SDK is uninitialized or unavailable.
 */
export const FEATURE_FLAG_DEFAULTS: FeatureFlagSet = {
  'demand-response-pages': false,
  'gaia-beta-tools': false,
  'gaia-process': false,
  'main-page-redirect': true,
  'predictive-drying-control': false,
  'theme-toggle': false,
};

/**
 * The scope for read-only access to the API.
 */
export const AUTH_SCOPE_READ_ONLY = 'openid profile email';

/**
 * The scope for read-write access to the API.
 */
export const AUTH_SCOPE = `${AUTH_SCOPE_READ_ONLY} write`;

/**
 * Display in the UI for missing a value.
 */
export const MISSING_VALUE = '--';
